
import axios from "axios";

export const state = {
    staffpositions: [],
};

export const getters = {
    staffpositions: state => state.staffpositions,
};

export const mutations = {
    setStaffPositions(state, newValue) {
        state.staffpositions = newValue
    },
};

export const actions = {
    fetchStaffPositions({ commit }) {
        axios.get('/staffpositions').then(res => {
            commit('setStaffPositions', res.data.staffpositions);
        })
    },
};
